{
  "familyId": "TAA-LEZEN-SAMENVATTEN",
  "questions": [
    {
      "id": "TAA-LEZEN-SAMENVATTEN-001",
      "familyId": "TAA-LEZEN-SAMENVATTEN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_samenvatten",
      "questionType": "multiple_choice",
      "question": "Een tekst gaat over de uitvinding van de fiets, de eerste modellen, en hoe de fiets nu overal ter wereld wordt gebruikt. Welke samenvatting past het best?",
      "options": [
        "De fiets is uitgevonden en heeft zich ontwikkeld tot een wereldwijd vervoermiddel.",
        "De eerste fietsen hadden geen pedalen en waren erg oncomfortabel.",
        "Fietsen zijn populair in Nederland omdat het land vlak is.",
        "Er zijn veel verschillende soorten fietsen, zoals racefietsen en mountainbikes."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Samenvatten", "content": "Een goede samenvatting bevat de hoofdgedachte van de hele tekst in 1-2 zinnen. Het gaat niet over één detail, maar over het grote plaatje.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_hoofdgedachte",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De beste samenvatting dekt alle drie de onderwerpen: uitvinding, ontwikkeling, en wereldwijd gebruik. Optie A doet dat in één zin. De andere opties gaan over slechts één detail.",
        "solutionSteps": ["De tekst gaat over: 1) uitvinding, 2) eerste modellen, 3) wereldwijd gebruik", "Een goede samenvatting dekt alle drie de onderwerpen", "Optie A: uitvinding + ontwikkeling + wereldwijd → dekt alles ✓"],
        "distractorExplanations": {
          "0": "Goed! Deze samenvatting dekt alle drie de onderwerpen van de tekst.",
          "1": "Je dacht waarschijnlijk dat dit een goede samenvatting is. Maar dit gaat alleen over de eerste modellen — één detail uit de tekst. Onthoud: een samenvatting dekt de hele tekst, niet één onderdeel.",
          "2": "Je dacht waarschijnlijk dat dit de tekst samenvat. Maar dit gaat over Nederland, terwijl de tekst over de hele wereld gaat. Onthoud: een samenvatting moet de hoofdgedachte van de tekst weergeven.",
          "3": "Je dacht waarschijnlijk dat dit een goede samenvatting is. Maar soorten fietsen worden niet als hoofdonderwerp genoemd. Onthoud: een samenvatting gaat over wat de tekst als geheel vertelt."
        }
      }
    },
    {
      "id": "TAA-LEZEN-SAMENVATTEN-002",
      "familyId": "TAA-LEZEN-SAMENVATTEN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_samenvatten",
      "questionType": "multiple_choice",
      "question": "Wat hoort NIET in een goede samenvatting van een tekst?",
      "options": ["De hoofdgedachte van de tekst", "Je eigen mening over het onderwerp", "De belangrijkste punten uit elke alinea", "De conclusie van de schrijver"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Regels voor samenvatten", "content": "In een samenvatting schrijf je alleen wat er in de tekst staat. Je eigen mening hoort er niet bij. Gebruik je eigen woorden, maar verander de inhoud niet.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_regels",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Je eigen mening hoort niet in een samenvatting. Een samenvatting beschrijft wat de schrijver vertelt, niet wat jij ervan vindt. De hoofdgedachte, belangrijkste punten en conclusie horen er wél in.",
        "solutionSteps": ["Een samenvatting = de tekst in het kort", "Wel: hoofdgedachte, belangrijkste punten, conclusie", "Niet: je eigen mening of extra informatie", "Je eigen mening hoort er niet in ✓"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de hoofdgedachte er niet in hoort. Maar de hoofdgedachte is juist het belangrijkste onderdeel van een samenvatting! Onthoud: begin je samenvatting altijd met de hoofdgedachte.",
          "1": "Goed! Je eigen mening hoort niet in een samenvatting. Je beschrijft alleen wat er in de tekst staat.",
          "2": "Je dacht waarschijnlijk dat de belangrijkste punten er niet in horen. Maar die vormen juist de kern van je samenvatting. Onthoud: neem uit elke alinea het belangrijkste punt mee.",
          "3": "Je dacht waarschijnlijk dat de conclusie er niet in hoort. Maar als de schrijver een conclusie trekt, neem je die mee in je samenvatting. Onthoud: de conclusie is het eindpunt van de tekst."
        }
      }
    },
    {
      "id": "TAA-LEZEN-SAMENVATTEN-003",
      "familyId": "TAA-LEZEN-SAMENVATTEN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_samenvatten",
      "questionType": "multiple_choice",
      "question": "Welke zin vat deze alinea het best samen?",
      "options": ["Bijen zijn essentieel voor de bestuiving van planten.", "Bijen maken honing van nectar.", "Er zijn steeds minder bijen in Nederland.", "Bloemen hebben mooie kleuren om bijen aan te trekken."],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "readingPassage", "data": {"passage": "Bijen zijn belangrijk voor de natuur. Ze bestuiven bloemen, waardoor planten zich kunnen voortplanten. Zonder bijen zouden veel gewassen niet groeien.", "instruction": "Lees de alinea"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Alinea samenvatten", "content": "Zoek de kernzin: de zin die het belangrijkste punt van de alinea bevat. Vaak is dat de eerste of laatste zin. Schrijf die in je eigen woorden.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_alinea",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De alinea gaat over het belang van bijen voor bestuiving. Alle drie de zinnen gaan daarover. Optie A vat dat samen in één zin. De andere opties gaan over dingen die niet in de alinea staan.",
        "solutionSteps": ["Lees de alinea: bijen → bestuiving → planten voortplanten → gewassen", "Kernpunt: bijen zijn belangrijk voor bestuiving", "Optie A zegt precies dat ✓"],
        "distractorExplanations": {
          "0": "Goed! Deze zin vat de kern van de alinea samen: bijen zijn belangrijk voor bestuiving.",
          "1": "Je dacht waarschijnlijk dat dit de alinea samenvat. Maar honing wordt niet genoemd in de alinea. Onthoud: een samenvatting bevat alleen informatie uit de tekst zelf.",
          "2": "Je dacht waarschijnlijk dat dit past. Maar de alinea zegt niets over minder bijen. Onthoud: voeg geen informatie toe die niet in de tekst staat.",
          "3": "Je dacht waarschijnlijk dat dit de alinea samenvat. Maar kleuren van bloemen worden niet genoemd. Onthoud: blijf bij wat er in de tekst staat."
        }
      }
    },
    {
      "id": "TAA-LEZEN-SAMENVATTEN-004",
      "familyId": "TAA-LEZEN-SAMENVATTEN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_samenvatten",
      "questionType": "multiple_choice",
      "question": "Wat is de eerste stap bij het samenvatten van een tekst?",
      "options": ["Je eigen mening opschrijven", "De hoofdgedachte bepalen", "Alle details opschrijven", "De tekst letterlijk overschrijven"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Stappenplan samenvatten", "content": "Stap 1: Bepaal de hoofdgedachte (waar gaat de tekst over?). Stap 2: Zoek de belangrijkste punten per alinea. Stap 3: Schrijf het in je eigen woorden.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_stappenplan",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De eerste stap is de hoofdgedachte bepalen: waar gaat de tekst over? Pas daarna zoek je de belangrijkste punten en schrijf je het in je eigen woorden.",
        "solutionSteps": ["Stap 1: Hoofdgedachte bepalen (waar gaat het over?)", "Stap 2: Belangrijkste punten per alinea zoeken", "Stap 3: In eigen woorden opschrijven", "De eerste stap is dus: hoofdgedachte bepalen ✓"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je begint met je mening. Maar je eigen mening hoort niet in een samenvatting. Onthoud: een samenvatting beschrijft de tekst, niet jouw mening.",
          "1": "Goed! De hoofdgedachte bepalen is altijd de eerste stap bij samenvatten.",
          "2": "Je dacht waarschijnlijk dat je alle details moet opschrijven. Maar een samenvatting bevat juist alleen de hoofdzaken, niet alle details. Onthoud: kort en krachtig, alleen het belangrijkste.",
          "3": "Je dacht waarschijnlijk dat je de tekst moet overschrijven. Maar samenvatten is juist het tegenovergestelde: je schrijft de tekst korter in je eigen woorden. Onthoud: samenvatten ≠ overschrijven."
        }
      }
    },
    {
      "id": "TAA-LEZEN-SAMENVATTEN-005",
      "familyId": "TAA-LEZEN-SAMENVATTEN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_samenvatten",
      "questionType": "ordering",
      "question": "Zet de stappen voor het samenvatten van een tekst in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {"items": ["Lees de hele tekst door", "Bepaal de hoofdgedachte", "Zoek per alinea het belangrijkste punt", "Schrijf de samenvatting in je eigen woorden"], "correctOrder": [0, 1, 2, 3]},
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Volgorde samenvatten", "content": "Eerst lezen, dan begrijpen (hoofdgedachte), dan analyseren (per alinea), dan schrijven. Je kunt pas samenvatten als je de tekst hebt begrepen.", "icon": "lightbulb"}}],
      "conceptId": "samenvatten_volgorde",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De juiste volgorde is: 1) Lees de hele tekst, 2) Bepaal de hoofdgedachte, 3) Zoek per alinea het belangrijkste punt, 4) Schrijf in je eigen woorden. Je moet eerst begrijpen voordat je kunt samenvatten.",
        "solutionSteps": ["Stap 1: Lees de hele tekst door (overzicht krijgen)", "Stap 2: Bepaal de hoofdgedachte (waar gaat het over?)", "Stap 3: Zoek per alinea het belangrijkste punt (details selecteren)", "Stap 4: Schrijf de samenvatting in je eigen woorden (verwerken)"]
      }
    }
  ]
}